<template>
  <div class="loading" v-show="isShow.isLDShow">

    <div class="loadingimg" id="loadingimg">
      <img src="./0.jpg" />
      <img src="./1.jpg" />
      <img src="./2.jpg" />
      <img src="./3.jpg" />
      <img src="./4.jpg" />
      <img src="./5.jpg" />
      <img src="./6.jpg" />
      <img src="./7.jpg" />
      <img src="./8.jpg" />
      <img src="./9.jpg" />

      <img src="./10.jpg" />
      <img src="./11.jpg" />
      <img src="./12.jpg" />
      <img src="./13.jpg" />
      <img src="./14.jpg" />
      <img src="./15.jpg" />
      <img src="./16.jpg" />
      <img src="./17.jpg" />
      <img src="./18.jpg" />
      <img src="./19.jpg" />

      <img src="./20.jpg" />
      <img src="./21.jpg" />
      <img src="./22.jpg" />
      <img src="./23.jpg" />
      <img src="./24.jpg" />
      <img src="./25.jpg" />
      <img src="./26.jpg" />
      <img src="./27.jpg" />
      <img src="./28.jpg" />
      <img src="./29.jpg" />

      <img src="./30.jpg" />
      <img src="./31.jpg" />
      <img src="./32.jpg" />
      <img src="./33.jpg" />
      <img src="./34.jpg" />
      <img src="./35.jpg" />
      <img src="./36.jpg" />
      <img src="./37.jpg" />
      <img src="./38.jpg" />
      <img src="./39.jpg" />

      <img src="./40.jpg" />
      <img src="./41.jpg" />
      <img src="./42.jpg" />
      <img src="./43.jpg" />
      <img src="./44.jpg" />
      <img src="./45.jpg" />
      <img src="./45.jpg" />
      <img src="./47.jpg" />
      <img src="./48.jpg" />
      <img src="./49.jpg" />
      <img src="./50.jpg" />
    </div>
    <div id="loadingnum"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      imgArr: [],
      preLoadImg: [
        { src: require('../page-input/hw-desc-bg.jpg') },
        { src: require('../page-input/ipt-bg.jpg') },
        { src: require('../page-input/ipt-btn.png') },
        { src: require('../page-input/ipt-com.png') },
        { src: require('../page-input/ipt-desc.png') },
        { src: require('../page-input/page-desc-box.png') },
        { src: require('../page-input/page-desc-para.png') },

        { src: require('../page-two/btn-again.png') },
        { src: require('../page-two/btn-share.png') },
        { src: require('../page-two/fn-bg.jpg') },
        { src: require('../page-two/fn-desc.png') },
        { src: require('../page-two/logo-gk.png') },
        { src: require('../page-two/logo-hw.png') },
        { src: require('../page-two/long-press.png') },
        { src: require('../page-two/poster-common-bg.jpg') },
        { src: require('../page-two/poster-common-desc.png') },
        { src: require('../page-two/poster-common-index.png') },
        { src: require('../page-two/poster-pop.png') },
        { src: require('../page-two/poster1-desc.png') },
        { src: require('../page-two/poster1-main.png') },
        { src: require('../page-two/poster1-sub1.png') },
        { src: require('../page-two/poster2-desc.png') },
        { src: require('../page-two/poster2-main.png') },
        { src: require('../page-two/poster2-sub1.png') },
        { src: require('../page-two/poster2-sub2.png') },
        { src: require('../page-two/poster3-desc.png') },
        { src: require('../page-two/poster3-main.png') },
        { src: require('../page-two/poster3-sub1.png') },
        { src: require('../page-two/poster3-sub2.png') },
        { src: require('../page-two/poster4-desc.png') },
        { src: require('../page-two/poster4-main.png') },
        { src: require('../page-two/poster4-sub1.png') },
        { src: require('../page-two/poster4-sub2.png') },
        { src: require('../page-two/poster5-desc.png') },
        { src: require('../page-two/poster5-main.png') },
        { src: require('../page-two/poster5-sub1.png') },
        { src: require('../page-two/poster5-sub2.png') },
        { src: require('../page-two/poster6-desc.png') },
        { src: require('../page-two/poster6-main.png') },
        { src: require('../page-two/poster6-sub1.png') },
        { src: require('../page-two/poster6-sub2.png') },
        { src: require('../page-two/poster7-desc.png') },
        { src: require('../page-two/poster7-main.png') },
        { src: require('../page-two/poster7-sub1.png') },
        { src: require('../page-two/poster8-desc.png') },
        { src: require('../page-two/poster8-main.png') },
        { src: require('../page-two/poster8-sub1.png') },
        { src: require('../page-two/poster8-sub2.png') },
        { src: require('../page-two/temp-qr.png') },

        { src: require('../../components/musicplayer/music-off.png') },
        { src: require('../../components/musicplayer/music-on.png') },

        { src: require('../../components/notification/g-blow.png') },
        { src: require('../../components/notification/g-press.png') },
        { src: require('../../components/notification/g-rub.png') },
        { src: require('../../components/notification/g-shake.png') },
        { src: require('../../components/notification/s1-notice.png') },
        { src: require('../../components/notification/s2-notice.png') },
        { src: require('../../components/notification/s3-notice.png') },
        { src: require('../../components/notification/s4-notice.png') },
        { src: require('../../components/notification/toast-container.png') },

        { src: require('../../components/prompt/airplane.gif') },
        { src: require('../../components/prompt/circuit.gif') },
        { src: require('../../components/prompt/cross.png') },
        { src: require('../../components/prompt/dna.gif') },
        { src: require('../../components/prompt/microscope.gif') },
        { src: require('../../components/prompt/p1-btn1.png') },
        { src: require('../../components/prompt/p1-btn2.png') },
        { src: require('../../components/prompt/p1-desc.png') },
        { src: require('../../components/prompt/p2-btn1.png') },
        { src: require('../../components/prompt/p2-btn2.png') },
        { src: require('../../components/prompt/p2-desc.png') },
        { src: require('../../components/prompt/p3-btn1.png') },
        { src: require('../../components/prompt/p3-btn2.png') },
        { src: require('../../components/prompt/p3-desc.png') },
        { src: require('../../components/prompt/p4-btn1.png') },
        { src: require('../../components/prompt/p4-btn2.png') },
        { src: require('../../components/prompt/p4-desc.png') },
        { src: require('../../components/prompt/p11-desc.png') },
        { src: require('../../components/prompt/p12-desc.png') },
        { src: require('../../components/prompt/p21-desc.png') },
        { src: require('../../components/prompt/p22-desc.png') },
        { src: require('../../components/prompt/p31-desc.png') },
        { src: require('../../components/prompt/p32-desc.png') },
        { src: require('../../components/prompt/p41-desc.png') },
        { src: require('../../components/prompt/p42-desc.png') },
        { src: require('../../components/prompt/prompt-container.png') },
        { src: require('../../components/prompt/radio.gif') },
        { src: require('../../components/prompt/spacecraft.gif') },
        { src: require('../../components/prompt/telescope.gif') },
        { src: require('../../components/prompt/x-ray.gif') },

        { src: require('../../components/rotate/phone_horizon.png') },

        { src: require('../../components/toast/p1-cloud-l.png') },
        { src: require('../../components/toast/p1-cloud-main.png') },
        { src: require('../../components/toast/p1-cloud-r.png') },
        { src: require('../../components/toast/p1-l1.png') },
        { src: require('../../components/toast/p1-l2.png') },
        { src: require('../../components/toast/p1-l3.png') },
        { src: require('../../components/toast/p1-l4.png') },
        { src: require('../../components/toast/p2-after.png') },
        { src: require('../../components/toast/p2-before.png') },
        { src: require('../../components/toast/p2.jpg') },
        { src: require('../../components/toast/p3-plane.png') },
        { src: require('../../components/toast/p3-wrapper.png') },
        { src: require('../../components/toast/p3.jpg') },
        { src: require('../../components/toast/p4-mirror.png') },
        { src: require('../../components/toast/p4-mirror2.png') },
        { src: require('../../components/toast/p4-wrapper.png') },
        { src: require('../../components/toast/p4.jpg') },
      ]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.isShow.isLDShow = false;
      // this.isShow.isKVShow = true
      this.isShow.isPOShow = true;
      this.$emit('startAni');
    },
    loadNextImg(imgID){
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt(imgID / len * 100)

        document.getElementById('loadingnum').innerHTML=_this.loadingNum+'%'
        let n=parseInt(_this.loadingNum/2)
        $('#loadingimg img').eq(n).show()
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          // console.log('completed')
          _this.go()
        }
      }
      curImg.src = curSrc
    }
  },
  mounted () {
    let imgID = 0
    setTimeout(() => {
      this.loadNextImg(imgID)
    }, 1000)

    let _w=$(window).width()
    let _h=$(window).height()

    let nowH=(1446/750*_w-_h)/2

    $('.loadingimg img').css({'top':'-'+nowH+'px'})

  }
}
</script>

<style lang="less" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
  .loadingimg {
    img{
      position: absolute;
      width: 100%;
      display: none;
    }
    img:nth-child(1){
      display: block;
    }
  }

  #loadingnum{
    position: absolute;
    top: 60vh;
    width: 100%;
    text-align: center;
    font-size:0.8em;
    color: #080808;
  }
}
</style>
